var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 26 27",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.682 24.627l-6.466-6.466a10.85 10.85 0 10-1.532 1.531l6.466 6.467a1.083 1.083 0 001.532-1.532zm-14.85-4.65A8.667 8.667 0 1119.5 11.31a8.677 8.677 0 01-8.667 8.666z",
    fill: "currentColor"
  })));
};

export default SvgSearch;